var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.ModalSuccess
  }, [_c('div', {
    class: _vm.$style.title
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.subtitle
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.subTitle) + "\n    ")])]), _vm._v(" "), _c('div', {
    class: _vm.$style.buttonWrapper
  }, [_c(_setup.SButton, {
    class: _vm.$style.button,
    on: {
      "click": _setup.handleClose
    }
  }, [_vm._v("\n      " + _vm._s(_vm.buttonLabel) + "\n    ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };